"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileMenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _NavMenuItem = require("../NavMenuItem.styled");

var _MobileMenu = require("./MobileMenu.styled");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MobileMenuItem = function MobileMenuItem(props) {
  var children = props.children,
      href = props.href,
      to = props.to,
      target = props.target,
      linkType = props.linkType;
  return _react.default.createElement(_MobileMenu.StyledMobileContainer, null, _react.default.createElement(_NavMenuItem.StyledMenuListItem, null, _react.default.createElement(_NavMenuItem.StyledMenuItemLink, {
    primary: linkType === 'primary',
    secondary: linkType === 'secondary',
    tertiary: linkType === 'tertiary',
    href: href,
    to: to,
    target: target
  }, _react.default.createElement(_MobileMenu.StyledMobileLinkText, {
    tag: "span"
  }, children))));
};
/**
 * Definition of default values for component props
 */


exports.MobileMenuItem = MobileMenuItem;
MobileMenuItem.defaultProps = {
  href: undefined,
  to: undefined,
  target: undefined,
  linkType: 'primary'
};
MobileMenuItem.propTypes = {
  href: _propTypes.default.string,
  to: _propTypes.default.string,
  target: _propTypes.default.string,
  linkType: (0, _propTypes.oneOf)(['primary', 'secondary', 'tertiary', undefined])
};